var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildingTypeMap, categoryClassMap, convertToClientBuildingTypeData, convertToClientCategoryClassData, convertToClientCountryData, convertToServerCountryData, } from '@core';
import { ConstructionClass } from '@features/guidbooks/types';
import { convertToClientConstructionTypeData, convertToServerConstructionTypeData, } from '../constructions';
export var convertToClientRequirementData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g;
    return (__assign(__assign({}, data), { constructionType: convertToClientConstructionTypeData(data.constructionClass), secondPlacementRoomId: (_b = (_a = data.secondPlacementRoom) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '', firstPlacementRoomId: (_d = (_c = data.firstPlacementRoom) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : '', buildingType: convertToClientBuildingTypeData(data.buildingType), standartShortName: (_e = data.standartShortName) !== null && _e !== void 0 ? _e : '', standartFullName: (_f = data.standartFullName) !== null && _f !== void 0 ? _f : '', countryType: convertToClientCountryData(data.countryType), standartValidityPeriod: data.standartValidityPeriod.split('-').reverse().join('-'), class: convertToClientCategoryClassData(data.class), noizeIsolationIndex: String(data.noizeIsolationIndex), noizeImpactIndex: String(data.noizeImpactIndex), notice: (_g = data.notice) !== null && _g !== void 0 ? _g : '' }));
};
export var convertToClientRequirementTableData = function (data) {
    var _a, _b, _c, _d, _e, _f, _g;
    return (__assign(__assign({}, data), { constructionType: convertToClientConstructionTypeData(data.constructionClass), secondPlacementRoom: (_b = (_a = data.secondPlacementRoom) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '', firstPlacementRoom: (_d = (_c = data.firstPlacementRoom) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '', buildingType: convertToClientBuildingTypeData(data.buildingType), standartShortName: (_e = data.standartShortName) !== null && _e !== void 0 ? _e : '', standartFullName: (_f = data.standartFullName) !== null && _f !== void 0 ? _f : '', countryType: convertToClientCountryData(data.countryType), standartValidityPeriod: data.standartValidityPeriod
            ? data.standartValidityPeriod.split('-').reverse().join('-')
            : '', class: convertToClientCategoryClassData(data.class), noizeIsolationIndex: String(data.noizeIsolationIndex), noizeImpactIndex: String(data.noizeImpactIndex), notice: (_g = data.notice) !== null && _g !== void 0 ? _g : '' }));
};
export var convertToServerRequirementData = function (data) {
    if (data.constructionType === ConstructionClass.Wall) {
        return {
            secondPlacementRoomId: data.secondPlacementRoomId || undefined,
            firstPlacementRoomId: data.firstPlacementRoomId || undefined,
            buildingType: buildingTypeMap.toServer[data.buildingType] || null,
            standartShortName: data.standartShortName || null,
            standartFullName: data.standartFullName || null,
            countryType: convertToServerCountryData(data.countryType),
            standartValidityPeriod: data.standartValidityPeriod.split('-').reverse().join('-'),
            class: categoryClassMap.toServer[data.class],
            noizeIsolationIndex: +data.noizeIsolationIndex,
            constructionClass: convertToServerConstructionTypeData(data.constructionType),
            notice: data.notice || null,
        };
    }
    return {
        secondPlacementRoomId: data.secondPlacementRoomId || undefined,
        firstPlacementRoomId: data.firstPlacementRoomId || undefined,
        buildingType: buildingTypeMap.toServer[data.buildingType] || null,
        standartShortName: data.standartShortName || null,
        standartFullName: data.standartFullName || null,
        countryType: convertToServerCountryData(data.countryType),
        standartValidityPeriod: data.standartValidityPeriod.split('-').reverse().join('-'),
        class: categoryClassMap.toServer[data.class],
        noizeIsolationIndex: +data.noizeIsolationIndex,
        noizeImpactIndex: +data.noizeImpactIndex,
        constructionClass: convertToServerConstructionTypeData(data.constructionType),
        notice: data.notice || null,
    };
};
export var convertToServerRequirementUpdateData = function (data) {
    if (data.constructionType === ConstructionClass.Wall) {
        return {
            id: data.id,
            secondPlacementRoomId: data.secondPlacementRoomId || undefined,
            firstPlacementRoomId: data.firstPlacementRoomId || undefined,
            buildingType: buildingTypeMap.toServer[data.buildingType] || null,
            standartShortName: data.standartShortName || null,
            standartFullName: data.standartFullName || null,
            countryType: convertToServerCountryData(data.countryType),
            standartValidityPeriod: data.standartValidityPeriod.split('-').reverse().join('-'),
            class: categoryClassMap.toServer[data.class],
            noizeIsolationIndex: +data.noizeIsolationIndex,
            constructionClass: convertToServerConstructionTypeData(data.constructionType),
            notice: data.notice || null,
        };
    }
    return {
        id: data.id,
        secondPlacementRoomId: data.secondPlacementRoomId || undefined,
        firstPlacementRoomId: data.firstPlacementRoomId || undefined,
        buildingType: buildingTypeMap.toServer[data.buildingType] || null,
        standartShortName: data.standartShortName || null,
        standartFullName: data.standartFullName || null,
        countryType: convertToServerCountryData(data.countryType),
        standartValidityPeriod: data.standartValidityPeriod.split('-').reverse().join('-'),
        class: categoryClassMap.toServer[data.class],
        noizeIsolationIndex: +data.noizeIsolationIndex,
        noizeImpactIndex: +data.noizeImpactIndex,
        constructionClass: convertToServerConstructionTypeData(data.constructionType),
        notice: data.notice || null,
    };
};
export var convertToServerFilterRequirementData = function (data) { return ({
    firstPlacementRoomName: data.firstPlacementRoom || null,
    secondPlacementRoomName: data.secondPlacementRoom || null,
    buildingType: buildingTypeMap.toServer[data.buildingType] || null,
    countryType: convertToServerCountryData(data.countryType) || null,
}); };
